// extracted by mini-css-extract-plugin
export default {"wrapper":"Place_wrapper__U8nw0","content":"Place_content__s-Srl","menu":"Place_menu__-4WnG","form":"Place_form__m0b3O","button":"Place_button__ByUjR","active":"Place_active__yyBmD"};